import { Handshake, Mail, ShieldAlert } from "lucide-react";
import { useEffect } from "react";

import { ROUTES } from "@/constants/routes";
import { BackHeader } from "@/features/Profile/components/BackHeader";
import { ProfileMenuLinkRow } from "@/features/Profile/components/ProfileMenuLinkRow";
import { gtmService } from "@/services/gtm-service";

export const Settings = () => {
  useEffect(() => {
    gtmService.trackSettingsView();
  }, []);

  return (
    <div className="mx-auto w-full max-w-xl px-4 py-6 sm:px-6">
      <BackHeader to={ROUTES.PROFILE} title="Settings" />

      <div className="mt-6 space-y-3">
        <ProfileMenuLinkRow
          icon={<Mail className="h-5 w-5" />}
          disabled
          title="Coming soon"
        >
          Change email
        </ProfileMenuLinkRow>
        <ProfileMenuLinkRow to={ROUTES.TERMS} icon={<Handshake className="h-5 w-5" />}>
          Terms of Service
        </ProfileMenuLinkRow>
        <ProfileMenuLinkRow
          to={ROUTES.PRIVACY}
          icon={<ShieldAlert className="h-5 w-5" />}
        >
          Privacy Policy
        </ProfileMenuLinkRow>
      </div>

      <p className="mt-10 text-center text-sm text-zinc-400">
        ©{new Date().getFullYear()} Dualio. All rights reserved.
      </p>
    </div>
  );
};
